import { Plus, Search } from 'lucide-react'

interface FloatingActionButtonProps {
  onClick: () => void
  onReview?: () => void
  label?: string
}

export function FloatingActionButton({ onClick, onReview, label = 'Quick Scan' }: FloatingActionButtonProps) {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3">
      {/* Review scans button (above) */}
      {onReview && (
        <button
          onClick={onReview}
          aria-label="Review Scans"
          className="w-14 h-14 rounded-full bg-quest-primary hover:bg-quest-primary/90 text-white shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
        >
          <Search className="w-7 h-7 group-hover:scale-110 transition-transform" />
          <span className="absolute right-full mr-3 px-3 py-1.5 bg-surface-card text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
            Review Scans
          </span>
        </button>
      )}

      {/* Quick scan button (primary) */}
      <button
        onClick={onClick}
        aria-label={label}
        className="w-14 h-14 rounded-full bg-quest-primary hover:bg-quest-primary/90 text-white shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
      >
        <Plus className="w-7 h-7 group-hover:scale-110 transition-transform" />
        <span className="absolute right-full mr-3 px-3 py-1.5 bg-surface-card text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
          {label}
        </span>
      </button>
    </div>
  )
}
